import SplunkOtelWeb, { SessionBasedSampler } from '@splunk/otel-web';
import SplunkSessionRecorder from '@splunk/otel-web-session-recorder';

import { useConfig } from '@hooks/Config';
import rcclUUID from '@rcg/uuid';
import { useEffect } from 'react';
import { BrandCode } from '../../types';

const getSplunkEnvironment = (env: string) => {
	switch (env) {
		case 'prd':
			return 'rcg-ecom-prd';
		case 'stg':
			return 'rcg-ecom-stg';
		case 'tst':
			return 'rcg-ecom-dev';
		default:
			return 'none';
	}
};

export const useSplunkRum = () => {
	const { env, envColor, brand, appVersion } = useConfig();

	const realm = 'us1';
	const isRoyalCaribbean = brand.code === BrandCode.RoyalCaribbean;
	const rumAccessToken = env === 'prd' ? 'wZcL2aKW-vSB_mHICZTUUw' : 'MA1Dwg5OqUtzBmBbZmHD5A';
	const applicationName = isRoyalCaribbean ? 'royal-caribbean-web' : 'celebrity-cruises-web';

	useEffect(() => {
		// eslint-disable-next-line no-console
		console.log('Initializing Splunk RUM');

		SplunkOtelWeb.init({
			realm,
			rumAccessToken,
			applicationName,
			deploymentEnvironment: getSplunkEnvironment(env),
			version: appVersion,
			tracer: {
				sampler: new SessionBasedSampler({
					ratio: env === 'prd' ? 0.1 : 1.0, // 10% sampling for PRD, 100% for lower envs
				}),
			},
			globalAttributes: {
				brand: brand.alpha3Code,
				envColor,
				userId: rcclUUID.getRWDId(),
				service: 'cruise-search-web',
			},
		});

		// Initialize Session Recorder after Splunk RUM is initialized
		SplunkSessionRecorder.init({
			realm,
			rumAccessToken,
			maskAllInputs: true,
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore Value is documented as boolean in the docs but type is string
			maskTextSelector: false,
		});
	}, [env, appVersion, brand.alpha3Code, envColor, rumAccessToken, applicationName]);
};
